export const setVehicleImages = vehicles => ({
  type: 'SET_VEHICLE_IMAGES',
  vehicles
});
